var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-5"},[_c('v-app',{staticClass:"container"},[(_vm.routerName != 'ForgotPassword')?_c('div',[(_vm.routerName != 'Login')?_c('div',[(_vm.routerName != 'Register')?_c('Topbar'):_vm._e()],1):_vm._e()]):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }